export default __webpack_public_path__ + "static/media/70.cc29805c.jpg";